module.exports = __webpack_public_path__ + "img/emissiondata.588bccc3.svg";